export default "__VITE_ASSET__CErZ7ZbF__"